import { useMemo } from 'react';

import { isMplPreApprovalOffer } from 'shared/lib';
import type { TPreapprovalOfferStep, TPreApprovalOfferStepData } from 'shared/types/TRankingService';

import { useConfirmationStepAnalyticsEvents } from '../../lib/useConfirmationStepAnalyticsEvents';
import { useDeliveryStepAnalyticsEvents } from '../../lib/useDeliveryStepAnalyticsEvents';
import { ConfirmationStep } from '../ConfirmationStep';
import { DeliveryStep } from '../DeliveryStep';

import type { TPreApprovalControlOffer } from './types';

type Props = {
  offer: TPreApprovalControlOffer;
  goNext: () => void;
  onClosePopup: () => void;
  currentStep?: TPreapprovalOfferStep;
  isStepFlowActive: boolean;
};

export const OfferStepPopup: FC<Props> = (props) => {
  const { offer, currentStep, goNext, onClosePopup, isStepFlowActive } = props;
  const deliveryFormEvents = useDeliveryStepAnalyticsEvents(offer);
  const confirmationFormEvents = useConfirmationStepAnalyticsEvents(offer);

  const offerData: TPreApprovalOfferStepData = useMemo(() => {
    if (isMplPreApprovalOffer(offer)) {
      return {
        preApprovalOfferId: offer.preApprovalOfferId,
        preApprovalStatus: 'OFFER',

        bankName: offer.organizationName,
        productName: offer.productName,

        productId: offer.productId,
        bankId: offer.organizationNewId,
      };
    }

    return {
      preApprovalOfferId: offer?.preApprovalOffer?.id,
      preApprovalStatus: offer.preApprovalStatus,

      bankName: offer.bankName,
      productName: offer.productName,

      productId: offer.id,
      bankId: offer.bankId,
    };
  }, [offer]);

  if (!isStepFlowActive) {
    return null;
  }

  switch (currentStep) {
    case 'delivery':
      return (
        <DeliveryStep
          offerData={offerData}
          onNext={goNext}
          onClose={onClosePopup}
          onSubmitEvent={deliveryFormEvents.onSubmitEvent}
          onChangeEvent={deliveryFormEvents.onChangeEvent}
          onShowEvent={deliveryFormEvents.onShowEvent}
        />
      );
    case 'confirmation':
      return (
        <ConfirmationStep
          offerData={offerData}
          onNext={goNext}
          onClose={onClosePopup}
          onShowEvent={confirmationFormEvents.onShowEvent}
          onSmsCodeEvent={confirmationFormEvents.onSmsCodeEvent}
        />
      );
    default:
      return null;
  }
};
